module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs5": "",
      "d-flex": "",
      "justify-start": "",
      "mr-3": ""
    }
  }, [_c('select-date', {
    attrs: {
      "placeholder": "Fecha de inicio",
      "icon": "event"
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.dateInit),
      callback: function($$v) {
        _vm.params.dateInit = $$v
      },
      expression: "params.dateInit"
    }
  }), _vm._v(" "), _c('select-date', {
    attrs: {
      "placeholder": "Fecha de fin"
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.dateEnd),
      callback: function($$v) {
        _vm.params.dateEnd = $$v
      },
      expression: "params.dateEnd"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('select-button', {
    attrs: {
      "placeholder": "Acción",
      "items": _vm.actions
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('table-run', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.hour))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.device))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.ip))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.activity))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.params.page = $$v
      },
      expression: "params.page"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62aba756","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/users/ActivityList.vue
// module id = 1650
// module chunks = 47